/*
 * @Author: your name
 * @Date: 2021-06-18 15:54:23
 * @LastEditTime: 2026-01-23 16:54:35
 * @LastEditors: dyf
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\api\config.js
 */
// import VueCookies from 'vue-cookies'
// import  store from '../store/index.js'
// export const callBackUrl = process.env.NODE_ENV === 'production' ? 'https://uat-yyzx.epec.com/' : 'http://uat-portal.epec.com:3002/projectA/#/dashboard'; // 新测试环境的
export const epecGrayGroup =
  process.env.NODE_ENV === 'development'
    ? 'uat-a'
    : process.env.NODE_ENV === 'uat'
      ? 'uat-a'
      : process.env.NODE_ENV === 'fix'
        ? 'bugfix'
        : '';
export const easySeries =
  process.env.NODE_ENV === 'production'
    ? 'https://mall.epec.com'
    : 'https://uat-mall.epec.com';
// 易保险
export const insuranceUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://baoxian.epec.com'
    : process.env.NODE_ENV === 'uat'
      ? 'http://uat-baoxian.epec.com'
      : process.env.NODE_ENV === 'fix'
        ? 'http://uat-baoxian.epec.com'
        : 'http://uat-baoxian.epec.com';

// 旧系统后台服务
export const baseUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://member.epec.com'
    : 'https://uat-member.epec.com';
export const ecBaseUrl =
  process.env.NODE_ENV === 'production' ? 'https://ec.epec.com' : '';

// 投标系统
export const bidSysBaseUrl =
  process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'pre'
    ? 'https://bid.epec.com'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uat-bid.epec.com'
      : 'http://uat-bid.epec.com:3002/projectA/#/';

export const epecMallUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://emall.epec.com'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uat-emall.epec.com'
      : process.env.NODE_ENV === 'fix'
        ? 'https://bugfix-emall.epec.com'
        : 'http://uat-emall.epec.com:3001';
// 在线商城 (老系统)
export const oldMallBaseUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://mall.epec.com'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uat-mall.epec.com'
      : 'https://uat-mall.epec.com';

export const epecBaseUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://passport.epec.com'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uat-passport.epec.com'
      : 'https://uat-passport.epec.com'; //
export const callBackUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://yyzx.epec.com/#'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uat-yyzx.epec.com/#'
      : process.env.NODE_ENV === 'fix'
        ? 'https://bugfix-yyzx.epec.com/#'
        : 'http://uat-yyzx.epec.com:3002/projectA/#/dashboard'; //
export const gateway =
  process.env.NODE_ENV === 'production'
    ? 'https://gateway.epec.com'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uat-gateway.epec.com'
      : process.env.NODE_ENV === 'fix'
        ? 'https://uat-gateway.epec.com'
        : 'https://uat-gateway.epec.com';
export const epecBaseUrlSsologin =
  process.env.NODE_ENV === 'production'
    ? `${epecBaseUrl}/sam/zh/process.do`
    : process.env.NODE_ENV === 'uat'
      ? `${epecBaseUrl}/sam/zh/process.do`
      : `${epecBaseUrl}/sam/zh/process.do`; //

export const baseOssUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://static.epec.com/'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uat-static.epec.com/'
      : // : "https://wuzhuang-uat02.oss-cn-beijing.aliyuncs.com/"; // 首页
      'https://uat-static.epec.com/'; // 首页
export const ubmUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://mall.epec.com/ubm/'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uat-mall.epec.com/ubm/'
      : process.env.NODE_ENV === 'fix'
        ? 'https://uat-mall.epec.com/ubm/'
        : 'https://uat-mall.epec.com/ubm/';

export const videoUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://emall.epec.com'
    : 'https://uat-emall.epec.com';
export const secure =
  process.env.NODE_ENV === 'production' ? true : process.env.NODE_ENV === 'uat'; //
// 密码加密
export const pwdEncryptUrl =
  process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'pre'
    ? 'https://passport.epec.com'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uat-passport.epec.com'
      : 'https://uat-passport.epec.com';

// 专属采购商城地址
export const purchaseUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://vip.epec.com'
    : process.env.NODE_ENV === 'pre'
      ? 'https://pre-vip.epec.com'
      : process.env.NODE_ENV === 'uat'
        ? 'https://uat-vip.epec.com'
        : process.env.NODE_ENV === 'fix'
          ? 'https://bugfix-vip.epec.com'
          : 'http://uat-vip.epec.com:3002'; //
// 在线客服 2.0商城的
export const onlineServiceUrl =
  process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'pre'
    ? 'https://uba.chat.sinopec.com/javascripts/7moorInit.js?accessId=bb8a75f0-20d1-11ec-98d3-8731d0ff922c&autoShow=true&language=ZHCN'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uba.chat.sinopec.com/javascripts/7moorInit.js?accessId=bb8a75f0-20d1-11ec-98d3-8731d0ff922c&autoShow=true&language=ZHCN'
      : 'https://uba.chat.sinopec.com/javascripts/7moorInit.js?accessId=bb8a75f0-20d1-11ec-98d3-8731d0ff922c&autoShow=true&language=ZHCN';
// 在线客服 易专采的
export const purchaseShoppingOnlineServiceUrl =
  process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'pre'
    ? 'https://uba.chat.sinopec.com/javascripts/7moorInit.js?accessId=09bc74d0-de7c-11ed-b747-612b6f0e0ec2&autoShow=true&language=ZHCN'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uat-webchat.chat.sinopec.com/javascripts/7moorInit.js?accessId=27b7d800-2f5b-11e9-bed6-9f6dfd4beaf7&autoShow=true&language=ZHCN'
      : 'https://uat-webchat.chat.sinopec.com/javascripts/7moorInit.js?accessId=27b7d800-2f5b-11e9-bed6-9f6dfd4beaf7&autoShow=true&language=ZHCN';
// 企业运营后台
export const yyhtUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://yyzx.epec.com'
    : process.env.NODE_ENV === 'pre'
      ? 'https://pre-yyzx.epec.com'
      : process.env.NODE_ENV === 'uat'
        ? 'https://uat-yyzx.epec.com'
        : process.env.NODE_ENV === 'fix'
          ? 'https://bugfix-yyzx.epec.com'
          : 'http://uat-yyzx.epec.com:3002/projectA/#/dashboard';

// 购物车、下单页整合的共同跳转
export const orderBaseUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://trade.epec.com'
    : process.env.NODE_ENV === 'pre'
      ? 'https://pre-trade.epec.com'
      : process.env.NODE_ENV === 'uat'
        ? 'https://uat-trade.epec.com'
        : process.env.NODE_ENV === 'fix'
          ? 'https://bugfix-trade.epec.com'
          : 'http://uat-trade.epec.com:3006'; //

export const bidDingUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://bidding.epec.com/'
    : process.env.NODE_ENV === 'uat'
      ? 'https://bidding-test.epec.com/'
      : 'https://bidding-test.epec.com/'; //
//  易物流gateway地址
export const ewuliuGateway =
  process.env.NODE_ENV === 'production'
    ? 'https://ewuliu-general.epec.com'
    : process.env.NODE_ENV === 'pre'
      ? 'https://ewuliu-general.epec.com'
      : 'http://dev-a-ewuliu-general.epec.com';

export const microBaseUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://yyzx.epec.com/epeceav3/#/'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uat-yyzx.epec.com/epeceav3/#/'
      : process.env.NODE_ENV === 'fix'
        ? 'https://bugfix-yyzx.epec.com/epeceav3/#/'
        : 'http://uat-yyzx.epec.com:3006/epeceav3/#/'; //

// axios 拦截器 AES 加解密对称密钥（与后端约定，按环境区分；非 production 共用同一份）
export const epecAesKey =
  process.env.NODE_ENV === 'production'
    ? 'h3fu9ezG9S4dmdgR_Ks3tyW6'
    : process.env.NODE_ENV === 'uat'
      ? 'zp5MFcCyzhgFnwbeQZg6acDH'
      : 'zp5MFcCyzhgFnwbeQZg6acDH';
      export const processEnv =
      process.env.NODE_ENV === 'production' ? "prod" : "uat"; //